module.exports = Jsw.skinUrl + "/icons/16/plesk/file-html.png?a1c021367bd1d987f31cf58c13a2d342";